import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2024SGM() {
  return <CategoryPage category="anexo30Y31Ano2024SGM" pageTitle="Sistema de Gestión de Medición 2024" />;
}

export default Anexo30Y31Ano2024SGM;
